import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';
import { siteInfo } from '../mock';

const Location = () => {
  return (
    <section id="hitta-oss" className="py-24 md:py-36 bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-2 reveal lg:sticky lg:top-28">
            <p className="text-[#8a8572] text-xs uppercase tracking-[0.4em] mb-5">— Hitta oss</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#2f3d30] leading-[1.05] mb-6">
              Hitta <em className="italic font-light">hit</em>.
            </h2>
            <p className="text-[#4a4a45] font-light leading-relaxed mb-8">
              Ni hittar oss i hjärtat av Ljungdalen, vid foten av Helagsfjället — en av Sveriges vackraste fjällmiljöer.
            </p>
            <div className="space-y-4 mb-10">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#8a6a3a] mt-0.5" strokeWidth={1.5} />
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a8572] mb-1">
                    Adress
                  </p>
                  <p className="text-[#2f3d30]">Ljungdalens Turridning</p>
                  <p className="text-[#4a4a45] font-light">{siteInfo.address}</p>
                </div>
              </div>
            </div>
            <a
              href={siteInfo.maps}
              target="_blank"
              rel="noreferrer"
              className="btn-ghost"
            >
              Öppna i Google Maps
              <ExternalLink className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>

          <div className="lg:col-span-3 reveal space-y-4">
            <div className="img-zoom aspect-[16/10] overflow-hidden border border-[#e8e1d2]">
              <img
                src="https://customer-assets.emergentagent.com/job_stable-modern/artifacts/g9dt76kd_lenas%20bilder%20978%20%282%29.jpg"
                alt="Skylt till Ljungdalens Turridning"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-[320px] md:h-[380px] overflow-hidden border border-[#e8e1d2] bg-[#f1ece0]">
              <iframe
                title="Ljungdalen map"
                src="https://www.google.com/maps?q=62.859135,12.785185&z=14&output=embed"
                className="w-full h-full grayscale contrast-110"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
